var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['card', _vm.$store.state.style]},[_c('div',{staticClass:"news"},[_c('div',{staticClass:"msg"},[_c('div',{staticClass:"van-multi-ellipsis--l3"},[_vm._v(_vm._s(_vm.data.title))])]),_c('img',{attrs:{"src":_vm.data.imgUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }